<!-- eslint-disable -->
<template lang="pug">
    svg(:width="elemWidth + 1" :height="elemHeight + 1" fill="none" xmlns="http://www.w3.org/2000/svg")
        rect(x="0.5" y="0.5" :width="elemWidth" :height="elemHeight" stroke="black")
</template>

<script>
/*eslint-disable*/

export default {
    props: {
        elemWidth: {
            type: Number,
            default: 40,
        },
        elemHeight: {
            type: Number,
            default: 40,
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
